enum SendDirectEmailType {
  RESENT_PASSWORD = 0,
  WELCOME_USER = 1,
  TEST_CAMPAIGN = 2,
  TEST_PROVIDER = 3,
}

export default SendDirectEmailType
